import React from 'react'

// styles

import Image from 'next/image'
import { Icon } from 'public/assets/v2/images/icons'
import { bannerContainer } from '../profile/styles/cover.css'
import { cssClass } from '@/shared/utils'
import { skeleton } from '@/components/skeleton/styles/index.css'

interface Props {
  src: string
  alt: string
  priority?: boolean
  showEditButton?: boolean
  loading?: boolean
  onClick?: () => void,
  className?: string
}

export const Cover: React.FC<Props> = ({
  src,
  alt,
  priority,
  showEditButton,
  loading,
  onClick,
  className,
}) => {
  return (
    <div className={cssClass([bannerContainer, skeleton, className])} onClick={onClick}>
      {!loading && (
        <>
          <Image
            src={src}
            alt={alt}
            priority={priority}
            key={alt}
            fill
            style={{ objectFit: 'cover', fill: 'cover' }}
            sizes="(max-width: 768px) 100vw, (max-width: 1024px) 90vw, (max-width: 1440px) 68vw, 1090px"
          />
          {showEditButton && (
            <div
              style={{
                position: 'absolute',
                top: '25px',
                right: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '12px',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                width: '40px',
                height: '40px',
                padding: '10px',
                gap: '10px',
              }}
            >
              <Icon.EditIconPen
                className="cl-white-primary"
                style={{ width: '20px', height: '20px' }}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}
